import { render, staticRenderFns } from "./TabDependency.vue?vue&type=template&id=4841ee9e&scoped=true&"
import script from "./TabDependency.vue?vue&type=script&lang=js&"
export * from "./TabDependency.vue?vue&type=script&lang=js&"
import style0 from "./TabDependency.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabDependency.vue?vue&type=style&index=1&id=4841ee9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841ee9e",
  null
  
)

export default component.exports